import React from 'react';
import Header from './../../inc/Header';
import Footer from './../../inc/Footer';
import Loader from './../../inc/Loader';
import Menu from './../../inc/Menu';

import ProjectGrid from './ProjectGrid';
import ProjectNav from './../ProjectNav';
import { fetchMenu } from "./../../../actions/menuActionCreators";
import { fetchPage } from "./../../../actions/pageActionCreators";
import { fetchOptions } from "./../../../actions/optionActionCreators";
import { fetchProjects } from "./../../../actions/projectActionCreators";
import { fetchPosts } from "./../../../actions/postActionCreators";
import ScrollToTop from './../../inc/ScrollToTop';



class Index extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			pageLoading: true,
			initCat:''
		}
	}
	componentDidMount() {
		let category = this.props.match.params.category;
		let _this = this;
		let before = performance.now();
		Promise.all([
			_this.props.dispatch(fetchMenu('menu')),
			_this.props.dispatch(fetchProjects()),
			_this.props.dispatch(fetchOptions()),
		]).then(() => {
			let after = performance.now();
			let diff = after-before;
			let media_length = process.env.REACT_APP_ANIMATION_DURATION;
			if(diff < media_length){
				setTimeout(() => {
					_this.setState({
						category:_this.state.initCat,
						pageLoading: false
					})
				},(media_length - diff))
			}else{
				_this.setState({
					category:_this.state.initCat,
					pageLoading: false
				})
			}
			_this.setState({
				initCat:category
			})
		});
	}

	render() {
		let _this = this;
		let { menu } = this.props.menu;
		let category = this.props.match.params.category ? this.props.match.params.category : 'all';
		let {initCat} = this.state;
		let loadedProjects = this.props.projects && Object.keys(this.props.projects.data).length ? this.props.projects.data.all : [];
		let loadedCategories = this.props.projects && Object.keys(this.props.projects.data).length ? this.props.projects.data.categories : [];
		let catData = loadedCategories.filter((cat, key) => {
			return cat.slug == category;
		});
		//console.log(loadedProjects);
		if(!catData.length) return [];

		let filteredProjects = loadedProjects.filter((project, key) => {
			return project.categories.some((cat) => {
				return cat.slug == category;
			})
		})
		return (
			<main className="mole__projects">
				{this.state.pageLoading &&
					<Loader />
				} 
				<ScrollToTop />
				<Header {...this.props}  />
				<ProjectNav {...this.props} loadedCategories={loadedCategories} category={catData[0]} type='grid' />
				<ProjectGrid {...this.props} loadedProjects={loadedProjects} filteredProjects={filteredProjects}  />
				<Menu {...this.props} />
				<Footer {...this.props} />
			</main>
		);
	}
}

export default Index;


// WEBPACK FOOTER //
// ./src/components/Projects/Grid/_index.js